import { render } from "./TransactionLaw.vue?vue&type=template&id=2cff1da4"
import script from "./TransactionLaw.vue?vue&type=script&lang=js"
export * from "./TransactionLaw.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TransactionLaw.vue?vue&type=style&index=0&id=2cff1da4&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__